import "./SidingReplacement.module.css";
import Header from "@/reusable_sections/Header";
import PatioDoorRepairServicesInVarennes from "./sections/PatioDoorRepairServicesInVarennes";
import SidingInstallationMaterials from "./sections/SidingInstallationMaterials";
import Footer from "@/reusable_sections/Footer";
export default function SidingReplacementPage() {
  return <div>
      <Header />
      <PatioDoorRepairServicesInVarennes />
      <SidingInstallationMaterials />
      <Footer />
    </div>;
}